var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.25C3.61328 5.25 2.5 4.13672 2.5 2.75C2.5 1.38281 3.61328 0.25 5 0.25C6.36719 0.25 7.5 1.38281 7.5 2.75C7.5 4.13672 6.36719 5.25 5 5.25ZM6.73828 5.875C8.18359 5.875 9.375 7.06641 9.375 8.51172V9.3125C9.375 9.83984 8.94531 10.25 8.4375 10.25H1.5625C1.03516 10.25 0.625 9.83984 0.625 9.3125V8.51172C0.625 7.06641 1.79688 5.875 3.24219 5.875H3.57422C4.00391 6.08984 4.49219 6.1875 5 6.1875C5.50781 6.1875 5.97656 6.08984 6.40625 5.875H6.73828Z",
    fill: "#A2B6CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationAvatar);
export default __webpack_public_path__ + "static/media/conversation-avatar.e2d1ac53e69094b2c177a4bb4d0fca3a.svg";
export { ForwardRef as ReactComponent };